import React, { useContext } from "react";
import { LocalizationContext } from "../contexts/localization-context";
import ArtVoteButton from "./ArtVoteButon";

const Art = ({ art, votedArtId, setVotedArtId, setActiveArt, campaignName, voteIsEnabled }) => {
    const [localizationState] = useContext(LocalizationContext);

    return (
        <div className="mb-96 md:mb-80 sm:mb-60 3xs:mb-48">
            <div
                className={`img-gradient relative w-full pt-14/10 3xs:pt-18/10 bg-cover bg-center bg-no-repeat ${
                    votedArtId === art.nodeId && voteIsEnabled ? " highlighted" : ""
                }`}
                style={{ backgroundImage: `url(${art.image})` }}
                onClick={() => setActiveArt(art)}
            >
                <div
                    className={`art-votes${
                        votedArtId === art.nodeId && voteIsEnabled ? " highlighted" : ""
                    }`}
                >
                    <span className="font-bold text-primary text-24 md:text-20 3xs:text-16 leading-2xs">
                        {art.votes}
                    </span>
                    <span className="mt-4 md:mt-0 text-14 3xs:text-12">
                        {localizationState.votes}
                    </span>
                </div>
                <ArtVoteButton
                    className="absolute centered-x bottom-50 z-10"
                    artId={art.nodeId}
                    votedArtId={votedArtId}
                    setVotedArtId={setVotedArtId}
                    campaignName={campaignName}
                />
            </div>
            <div className="flex flex-col items-center -mt-10">
                <div className="img-ring z-10">
                    <img
                        className="w-40 h-40 rounded-full box-content"
                        src={art.authorImage}
                        alt={art.authorName}
                    />
                </div>
                <span className="mt-10 3xs:text-12">{art.authorName}</span>
            </div>
        </div>
    );
};

export default Art;
